<template>
  <div class="dash-left-side dash-list-side" ref="studioList">
    <div class="plot-header-row">
      <span class="plot-title">Plots</span>
      <v-img :src="dash_create" alt="create" @click="createPlot" class="set-cursor create-btn-compact"></v-img>
    </div>
    <v-divider></v-divider>
    <div class="tab-div dash-access-toggle justify-space-between tabs-row">
      <v-btn-toggle
        v-model="isShared"
        class="axis-toggle"
        mandatory
        @update:modelValue="handleAccessToggleChange"
      >
        <v-btn :value="false" class="switch-btn" outlined>My Plots</v-btn>
        <v-btn :value="true" class="switch-btn" outlined>Shared</v-btn>
      </v-btn-toggle>
    </div>
    <div class="search-row">
      <v-text-field
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        placeholder="Search Plot"
        dense
        hide-details
        class="search-bar"
      />
    </div>
    <DashChartListingLoader v-if="showLoader == true" />
    <div class="dash-list-public" v-else>
      <div v-if="filteredCharts.length === 0">
        <h6>No Plots Found</h6>
      </div>
      <div
        v-for="(chart, index) in filteredCharts"
        :key="index"
        class="dash-list-items"
        :class="{ active: selectedChartId === chart.ID }"
        @click="selectChart(chart)"
        style="position: relative;"
      >
        <span class="dash-name" :title="chart.Name">{{ chart.Name }}</span>
        <div class="chart-actions">
          <img :src="GlobeSimple" alt="globe" title="Shared" v-if="isPublicChartByUser(chart)" class="globe-icon" />
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import api from "../../../axiosInterceptor";
import DashChartListingLoader from "../Loaders/DashChartListingLoader.vue";
import { mapGetters } from "vuex";

export default {
  name: "StudioList",
  components: { DashChartListingLoader },
  data() {
    return {
      GlobeSimple: require("../../../assets/Svg/GlobeSimple.svg"),
      chartsArr: [],
      isShared: false,
      showLoader: true,
      selectedChartId: null,
      searchQuery: "",
      selectedXAxisKey: [],
      selectedYAxisKey: [],
      selectedZAxisKey: [],
      selectedColorGroupKey: null,
      // AbortController instances for request cancellation
      dataFetchAbortController: null,
      tableTypeAbortController: null,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    filteredCharts() {
      const userEmail = this.$store.getters["tenantId/getUser"]?.username;
      let filtered = this.chartsArr.filter((chart) =>
        this.isShared
          ? chart.AccessLevel === "public"
          : chart.AccessLevel === "private" ||
            (chart.AccessLevel === "public" && chart.CreatedBy === userEmail)
      );
      
      // Debug logging
      const publicChartsByUser = this.chartsArr.filter(chart => chart.AccessLevel === 'public' && chart.CreatedBy === userEmail);
      const allPublicCharts = this.chartsArr.filter(chart => chart.AccessLevel === 'public');
    
      
    
      
      if (this.searchQuery) {
        filtered = filtered.filter((chart) =>
          chart.Name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
      return filtered;
    },
    dash_create() {
      return this.isDarkMode ? require("../../../assets/Svg/Dashboard/create-btn-stu-dark.svg") : require("../../../assets/Svg/Dashboard/create-btn-stu.svg");
    },
  },
  watch: {
    isDarkMode(newVal) {
      this.dash_create = newVal ? require("../../../assets/Svg/Dashboard/create-btn-stu-dark.svg") : require("../../../assets/Svg/Dashboard/create-btn-stu.svg");
    },
  },
  beforeDestroy() {
    // Cancel all pending requests when component is destroyed
    this.cancelAllRequests();
  },
  beforeUnmount() {
    // Cancel all pending requests when component is unmounted (Vue 3 compatibility)
    this.cancelAllRequests();
  },
  methods: {
    // Request cancellation methods
    cancelDataFetchRequest() {
      if (this.dataFetchAbortController) {
        this.dataFetchAbortController.abort();
        this.dataFetchAbortController = null;
      }
    },
    
    cancelTableTypeRequest() {
      if (this.tableTypeAbortController) {
        this.tableTypeAbortController.abort();
        this.tableTypeAbortController = null;
      }
    },
    
    
    // Cancel all pending requests
    cancelAllRequests() {
      this.cancelDataFetchRequest();
      this.cancelTableTypeRequest();
    },

    handleAccessToggleChange() {
      // No-op, v-model handles isShared
    },
    async selectChart(chart) {
      
      
      this.selectedChartId = chart.ID;
      // Store complete chart data in localStorage
      localStorage.setItem('savedChartData', JSON.stringify(chart));
      
      
      await this.tableTypeChange(chart.TableType);
      
      // Check for pending filter data and apply it if available
      this.checkAndApplyPendingFilter(chart);
      
      this.getTableData(chart);
      this.$emit("selected-plot", chart);
    },
    async getTableData(chart) {
      this.selectedXAxisKey = chart.XAxisColumn;
      this.selectedYAxisKey = chart.YAxisColumn;
      this.selectedZAxisKey = chart.ZAxisColumn;
      this.selectedColorGroupKey = chart.GroupColumn;
      
      // Cancel any previous data fetch request
      this.cancelDataFetchRequest();
      
      // Create new AbortController for this request
      this.dataFetchAbortController = new AbortController();
      
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      this.$emit("sample-error", "");
      
      // Retrieve the selected table type from localStorage
      var selectedType = localStorage.getItem("selectedTableType");
      
      // Initialize an array for selected columns
      let selectedColumns = [];
      
      // Safely add each key to selectedColumns if it exists and is not empty
      if (typeof chart.XAxisColumn === "string" && chart.XAxisColumn.trim() !== "") {
        selectedColumns.push(chart.XAxisColumn.trim());
      }
      if (Array.isArray(chart.YAxisColumn)) {
        // If selectedYAxisKey is an array, add its non-empty trimmed values
        selectedColumns.push(
          ...chart.YAxisColumn
            .filter((key) => typeof key === "string" && key.trim() !== "")
            .map((key) => key.trim())
        );
      } else if (typeof chart.YAxisColumn === "string" && chart.YAxisColumn.trim() !== "") {
        // Split by comma, trim each, and push non-empty values
        chart.YAxisColumn.split(',').map(col => col.trim()).forEach(col => {
          if (col) selectedColumns.push(col);
        });
      }
      if (typeof chart.ZAxisColumn === "string" && chart.ZAxisColumn.trim() !== "") {
        selectedColumns.push(chart.ZAxisColumn.trim());
      }
      if (typeof chart.GroupColumn === "string" && chart.GroupColumn.trim() !== "") {
        selectedColumns.push(chart.GroupColumn.trim());
      }
      
      // Filter out any invalid entries as an extra safety measure
      selectedColumns = selectedColumns.filter((column) => column);
      if (selectedColumns.length === 0) {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        return;
      }
      
      try {
        // Build query parameters object starting with selectColumns
        const queryParams = {
          selectColumns: JSON.stringify(selectedColumns)
        };
        
        // Add filter parameters from the chart's Filter object if they exist
        if (chart.Filter) {
          const chartFilter = chart.Filter;
          
          // Only add filters to params if they have values
          if (chartFilter.asset && chartFilter.asset.length) {
            queryParams.asset = JSON.stringify(chartFilter.asset);
          }
          if (chartFilter.field && chartFilter.field.length) {
            queryParams.field = JSON.stringify(chartFilter.field);
          }
          if (chartFilter.well && chartFilter.well.length) {
            queryParams.well = JSON.stringify(chartFilter.well);
          }
          if (chartFilter.reservoir && chartFilter.reservoir.length) {
            queryParams.reservoir = JSON.stringify(chartFilter.reservoir);
          }
          if (chartFilter.fluidType && chartFilter.fluidType.length) {
            queryParams.fluidType = JSON.stringify(chartFilter.fluidType);
          }
          if (chartFilter.sampleType && chartFilter.sampleType.length) {
            queryParams.sampleType = JSON.stringify(chartFilter.sampleType);
          }
          if (chartFilter.fluidClassification && chartFilter.fluidClassification.length) {
            queryParams.fluidClassification = JSON.stringify(chartFilter.fluidClassification);
          }
          if (chartFilter.fluidSampleID && chartFilter.fluidSampleID.length) {
            queryParams.fluidSampleID = JSON.stringify(chartFilter.fluidSampleID);
          }
          if (chartFilter.fluidSampleContainerID && chartFilter.fluidSampleContainerID.length) {
            queryParams.fluidSampleContainerID = JSON.stringify(chartFilter.fluidSampleContainerID);
          }
          if (chartFilter.source) {
            queryParams.source = `"${chartFilter.source}"`;
          }
          if (chartFilter.depth) {
            queryParams.depth = JSON.stringify(chartFilter.depth);
          }
          if (chartFilter.formationPressure) {
            queryParams.formationPressure = JSON.stringify(chartFilter.formationPressure);
          }
          if (chartFilter.formationTemperature) {
            queryParams.formationTemperature = JSON.stringify(chartFilter.formationTemperature);
          }
        }
        
        // Build query string from all parameters
        const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");
        
        
        // Make a single API call with both filter and column parameters
        const response = await api.get(
          `public/api/tables/data/${selectedType}?${queryString}`,
          { signal: this.dataFetchAbortController.signal }
        );
        
        // Check if the API response is successful
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          if (response.data.error) {
            this.$emit("sample-error", response.data.error);
            return;
          }
          
          this.tableData = response.data.data.samples.rows;
          
          if (this.tableData === null) {
            this.$emit("sample-error", "Data is not available to plot chart.");
            return;
          }
          
          await this.extractAllAxisData();
        } else if (response && response.data && response.data.message) {
          this.$emit("sample-error", response.data.message);
        } else if (response && response.data && response.data.error) {
          this.$emit("sample-error", response.data.error);
        } else {
          this.$emit("sample-error", "Error fetching table data.");
        }
      } catch (error) {
        // Check if the request was cancelled
        if (error.name === 'AbortError') {
          return;
        }
        
        this.$emit("sample-error", "An error occurred while fetching data.");
      } finally {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        // Clean up the AbortController
        this.dataFetchAbortController = null;
      }
    },
    async extractAllAxisData() {
      // Safely convert selectedYAxisKey to array
      const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
        ? this.selectedYAxisKey 
        : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];

      if (!this.tableData || this.tableData.length === 0) {
        return;
      }

      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      
      this.xAxisData = [];
      this.yAxisData = [];
      this.zAxisData = [];
      this.colorGroupData = [];
      
      this.autoFixColumnNames();
      
      const isLargeDataset = this.tableData.length > this.dataChunkSize;
      try {
        // X-AXIS EXTRACTION
        if (this.selectedXAxisKey) {
          const selectedColumn = this.xAxisItems.find(
            (item) => item.name === this.selectedXAxisKey
          );
          
          if (isLargeDataset) {
            this.xAxisData = await this.findXAxisDataChunked();
          } else {
            this.xAxisData = this.findXAxisData();
          }
          
          var allCaptions = this.tableData?.map((row) => row.caption || "");
          this.$emit("x-axis-selected", { 
            data: this.xAxisData, 
            displayName: selectedColumn ? selectedColumn.displayName : this.selectedXAxisKey, 
            caption: allCaptions 
          });
        }

        // Y-AXIS EXTRACTION
        if (yAxisKeys.length > 0) {
          this.yAxisData = this.findYAxisData();
          const allCaptions = this.tableData?.map((row) => row.caption || "");
          const filteredYAxisKeys = yAxisKeys[0]
            .split(',')
            .filter(key => key !== this.selectedColorGroupKey);

          const yAxisDisplayNames = Array.from(
            new Set(
              filteredYAxisKeys
                .flatMap(key => (typeof key === "string" ? key.split(",") : [key]))
                .map(k => k.trim())
                .filter(k => k && k !== this.selectedColorGroupKey)
            )
          ).map((key) => {
            const selectedColumn = this.yAxisItems?.find((item) => item.name === key);
            return selectedColumn ? selectedColumn.displayName : key;
          });
          
          this.$emit("y-axis-selected", { 
            data: this.yAxisData, 
            displayNames: yAxisDisplayNames, 
            caption: allCaptions 
          });
        }

        // Z-AXIS and COLOR GROUPING
        if (this.selectedZAxisKey) {
          
          
          const selectedColumn = this.zAxisItems.find(
            (item) => item.name === this.selectedZAxisKey
          );
          
          // Fallback search if exact match not found
          let selectedColumnFallback = selectedColumn;
          if (!selectedColumnFallback) {
            selectedColumnFallback = this.zAxisItems.find(
              (item) => item.name.toLowerCase() === this.selectedZAxisKey.toLowerCase()
            );
          }
          
          // Partial match search if still no match
          if (!selectedColumnFallback) {
            selectedColumnFallback = this.zAxisItems.find(
              (item) => item.name.toLowerCase().includes(this.selectedZAxisKey.toLowerCase()) ||
                       this.selectedZAxisKey.toLowerCase().includes(item.name.toLowerCase())
            );
          }
          
          if (isLargeDataset) {
            this.zAxisData = await this.findZAxisDataChunked();
          } else {
            this.zAxisData = this.findZAxisData();
          }
          
          const displayName = selectedColumnFallback ? selectedColumnFallback.displayName : this.selectedZAxisKey;
          
          
          this.$emit("z-axis-selected", { 
            data: this.zAxisData, 
            displayName: displayName
          });
        }
        
        this.handleGroupSelection();

        // Force a small delay to ensure all emissions are processed
        await new Promise(resolve => setTimeout(resolve, 100));
      
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        
        // Process color group data if a color group is selected
        if (this.selectedColorGroupKey && this.selectedColorGroupKey.trim() !== '') {
          this.processColorGroupData();
        } else {
          // Clear color group data if no color group is selected
          this.$emit("grouped-y-axis-data", {});
          this.$emit("grouped-x-axis-data", {});
          this.$emit("grouped-z-axis-data", {});
          this.$emit("color-group-key", "");
          this.$emit("color-group-display-name", "");
        }
        
        this.$nextTick(() => {
          this.$emit("chart-updated");
          // Emit table data for comprehensive CSV export
          if (this.tableData && this.tableData.length > 0) {
            this.$emit("table-data", this.tableData);
          }
        });

      } catch (error) {
        // Only keep error for actual error reporting
        console.error('❌ Error during data extraction:', error);
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        this.$emit("sample-error", "Error processing chart data");
      }
    },
    processColorGroupData() {
      if (!this.selectedColorGroupKey || !this.tableData || this.tableData.length === 0) {
        return;
      }
      
      // Find unique color group values
      const colorGroupValues = [...new Set(this.tableData.map(row => row[this.selectedColorGroupKey]).filter(value => value !== null && value !== undefined))];
      
      if (colorGroupValues.length === 0) {
        return;
      }
      
      // Initialize grouped data objects
      const groupedYAxisData = {};
      const groupedXAxisData = {};
      const groupedZAxisData = {};
      
      // Initialize the grouped arrays for each unique value
      colorGroupValues.forEach(value => {
        groupedYAxisData[value] = [];
        groupedXAxisData[value] = [];
        groupedZAxisData[value] = [];
      });
      
      // Group the data
      this.tableData.forEach(row => {
        const colorGroupValue = row[this.selectedColorGroupKey];
        if (colorGroupValues.includes(colorGroupValue)) {
          // Collect yAxis data - handle both array and string formats
          const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
            ? this.selectedYAxisKey 
            : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
            
          if (yAxisKeys.length > 0) {
            const yAxisRowData = yAxisKeys.map(key => {
              const decimalKey = `${key}_decimal`;
              if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
                const value = parseFloat(row[key]);
                if (!isNaN(value)) {
                  const maxDecimals = Math.min(row[decimalKey], 6);
                  return value.toFixed(maxDecimals);
                }
              }
              return row[key];
            });
            groupedYAxisData[colorGroupValue].push(yAxisRowData);
          }
          
          // Collect xAxis data
          if (this.selectedXAxisKey) {
            const xAxisRowData = row[this.selectedXAxisKey];
            groupedXAxisData[colorGroupValue].push(xAxisRowData);
          }
          
          // Collect zAxis data
          if (this.selectedZAxisKey) {
            const zAxisRowData = row[this.selectedZAxisKey];
            groupedZAxisData[colorGroupValue].push(zAxisRowData);
          }
        }
      });
      
      // Emit grouped data
      this.$emit("grouped-y-axis-data", groupedYAxisData);
      this.$emit("grouped-x-axis-data", groupedXAxisData);
      this.$emit("grouped-z-axis-data", groupedZAxisData);
      this.$emit("color-group-key", this.selectedColorGroupKey);
      
      // Emit color group display name
      const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.selectedColorGroupKey);
      const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.selectedColorGroupKey;
      this.$emit("color-group-display-name", colorGroupDisplayName);
    },
    findYAxisData() {
      // Convert selectedYAxisKey to array if it isn't already
      const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
        ? this.selectedYAxisKey 
        : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];

      if (!this.tableData || !this.tableData.length) {
        return [];
      }

      if (!yAxisKeys.length) {
        return [];
      }

      const firstRow = this.tableData[0];

      var columnData = yAxisKeys.map((col) => {
        // Try to find the actual column name in the data
        let actualColumnName = col;
        if (!(col in firstRow)) {
          // Try case-insensitive match
          const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
            key.toLowerCase() === col.toLowerCase()
          );
          if (caseInsensitiveMatch) {
            actualColumnName = caseInsensitiveMatch;
          } else {
            // Try partial match
            const partialMatch = Object.keys(firstRow).find(key => 
              key.includes(col) || col.includes(key)
            );
            if (partialMatch) {
              actualColumnName = partialMatch;
            } else {
              // Try to find similar column names
              const similarKeys = Object.keys(firstRow).filter(key => 
                key.toLowerCase().includes(col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) ||
                col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(key.toLowerCase())
              );
              if (similarKeys.length > 0) {
                actualColumnName = similarKeys[0];
              }
            }
          }
        }
        
        const decimalKey = `${actualColumnName}_decimal`;
        
        const rawData = this.tableData.map((row) => {
          const value = row[actualColumnName];
          const decimalValue = row[decimalKey];
          // Handle decimal formatting
          if (decimalValue !== undefined && decimalValue !== null) {
            const numValue = parseFloat(value);
            if (!isNaN(numValue)) {
              const maxDecimals = Math.min(decimalValue, 6);
              const numericValue = parseFloat(numValue.toFixed(maxDecimals));
              return numericValue;
            }
          }
          return value;
        });
        return rawData;
      });
      return columnData;
    },
    findXAxisData() {
      if (!this.tableData || !this.tableData.length) {
        return [];
      }
      if (!this.selectedXAxisKey) {
        return [];
      }
      const firstRow = this.tableData[0];
      let actualColumnName = this.selectedXAxisKey;
      if (!(this.selectedXAxisKey in firstRow)) {
        const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
          key.toLowerCase() === this.selectedXAxisKey.toLowerCase()
        );
        if (caseInsensitiveMatch) {
          actualColumnName = caseInsensitiveMatch;
        } else {
          const partialMatch = Object.keys(firstRow).find(key => 
            key.includes(this.selectedXAxisKey) || this.selectedXAxisKey.includes(key)
          );
          if (partialMatch) {
            actualColumnName = partialMatch;
          }
        }
      }
      const decimalKey = `${actualColumnName}_decimal`;
      const rawData = this.tableData.map((row) => {
        const value = row[actualColumnName];
        const decimalValue = row[decimalKey];
        if (decimalValue !== undefined && decimalValue !== null) {
          const numValue = parseFloat(value);
          if (!isNaN(numValue)) {
            const maxDecimals = Math.min(decimalValue, 6);
            const formattedValue = numValue.toFixed(maxDecimals);
            return formattedValue;
          }
        }
        return value;
      });
      return rawData;
    },
    findZAxisData() {
      if (this.tableData && this.selectedZAxisKey) {
        const decimalKey = `${this.selectedZAxisKey}_decimal`;
        return this.tableData.map((row) => {
          if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
            const value = parseFloat(row[this.selectedZAxisKey]);
            if (!isNaN(value)) {
              // Limit decimal places to prevent excessive digits
              const maxDecimals = Math.min(row[decimalKey], 6);
              return parseFloat(value.toFixed(maxDecimals)); // Convert back to number
            }
          }
          return row[this.selectedZAxisKey];
        });
      }
      return [];
    },
    findcolorGroupData() {
      if (this.tableData && this.selectedColorGroupKey) {
        var columnData = this.tableData.map(row => row[this.selectedColorGroupKey]);
        const uniqueValues = [...new Set(columnData.filter(item => item !== undefined && item !== null))];
        return uniqueValues;
      }
      return [];
    },
    autoFixColumnNames() {
      if (!this.tableData || !this.tableData.length) {
        return;
      }
      const firstRow = this.tableData[0];
      const availableKeys = Object.keys(firstRow);
      // Fix X-axis column name
      if (this.selectedXAxisKey && !(this.selectedXAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedXAxisKey, availableKeys);
        if (fixedName) {
          this.selectedXAxisKey = fixedName;
        }
      }
      // Fix Y-axis column names
      if (this.selectedYAxisKey) {
        let yAxisKeys = Array.isArray(this.selectedYAxisKey)
          ? this.selectedYAxisKey
          : [this.selectedYAxisKey];
        yAxisKeys = yAxisKeys
          .flatMap(key => typeof key === "string" ? key.split(",") : [key])
          .map(key => typeof key === "string" ? key.trim() : key)
          .filter(key => key !== undefined && key !== null && key !== "");
        if (this.selectedColorGroupKey) {
          yAxisKeys = yAxisKeys.filter(col => col !== this.selectedColorGroupKey);
        }
        if (yAxisKeys.length > 0) {
          const fixedYKeys = yAxisKeys.map(col => {
            if (col && !(col in firstRow)) {
              const fixedName = this.findBestColumnMatch(col, availableKeys);
              if (fixedName) {
                return fixedName;
              }
            }
            return col;
          });
          this.selectedYAxisKey = Array.isArray(this.selectedYAxisKey)
            ? fixedYKeys
            : fixedYKeys[0];
        } else {
          this.selectedYAxisKey = Array.isArray(this.selectedYAxisKey) ? [] : null;
        }
      }
      // Fix Z-axis column name
      if (this.selectedZAxisKey && !(this.selectedZAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedZAxisKey, availableKeys);
        if (fixedName) {
          this.selectedZAxisKey = fixedName;
        }
      }
      // Fix color group column name
      if (this.selectedColorGroupKey && !(this.selectedColorGroupKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedColorGroupKey, availableKeys);
        if (fixedName) {
          this.selectedColorGroupKey = fixedName;
        }
      }
    },
    findBestColumnMatch(selectedName, availableKeys) {
      const searchNames = Array.isArray(selectedName) 
        ? selectedName 
        : [selectedName];
      const safeToLower = (str) => String(str || '').toLowerCase();
      for (const name of searchNames) {
        const currentSearch = safeToLower(name);
        const exactMatch = availableKeys.find(key => 
          safeToLower(key) === currentSearch
        );
        if (exactMatch) return exactMatch;
        const partialMatch = availableKeys.find(key => {
          const lowerKey = safeToLower(key);
          return (
            lowerKey.includes(currentSearch) ||
            currentSearch.includes(lowerKey)
          );
        });
        if (partialMatch) return partialMatch;
        const cleanSelected = currentSearch.replace(/[^a-zA-Z0-9]/g, '');
        const cleanMatch = availableKeys.find(key => {
          const cleanKey = safeToLower(key).replace(/[^a-zA-Z0-9]/g, '');
          return (
            cleanKey.includes(cleanSelected) || 
            cleanSelected.includes(cleanKey)
          );
        });
        if (cleanMatch) return cleanMatch;
      }
      return null;
    },
    async handleGroupSelection() {
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length !=='') {
        if (this.colorGroupChanged) {
          if (this.colorGroupAbortController) {
            this.colorGroupAbortController.abort();
          }
          this.colorGroupAbortController = new AbortController();
          const signal = this.colorGroupAbortController.signal;
          let defaultFilterID = localStorage.getItem("defaultFilter");
          let filterActive = localStorage.getItem("filterActive")
          let selectedFilterId = localStorage.getItem("selectedFilterId")
          this.saveChartData();
          if (defaultFilterID || filterActive || selectedFilterId) {
            let filterData = this.savedFilterData
            let type = this.savedType
            this.onlyApiCall = true
            await this.getTableDataAgainstFilter({ filterData, type }, signal);
          }
          else {
            
            await this.getTableData(signal);
          }
          await this.extractAllAxisData();
        }
        this.colorGroupChanged = false
        this.colorGroupData = this.findcolorGroupData();
        if (this.selectedChartTypeName != "Histogram") {
          if (!this.yAxisData.length) {
            return;
          }
        }
        if (!this.xAxisData.length) {
          return;
        }
        const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
          ? this.selectedYAxisKey 
          : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
        if (yAxisKeys.length > 1) {
          this.selectedYAxisKey = yAxisKeys.slice(0, 1);
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.YAxisColumn = this.selectedYAxisKey.join(",")
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
          const yAxisDisplayNames = this.selectedYAxisKey.map(key => {
            const selectedColumn = this.yAxisItems.find(item => item.name === key);
            return selectedColumn ? selectedColumn.displayName : key;
          });
          this.$emit("y-axis-selected", { displayNames: yAxisDisplayNames });
        }
        
        // Color group data processing is already handled by extractAllAxisData()
        // No need to duplicate the processing here as it causes histogram bins to be calculated twice
        
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.GroupColumn = this.selectedColorGroupKey
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
      }
      else {
        this.colorGroupData = [];
        this.$emit("grouped-y-axis-data", {});
        this.$emit("grouped-x-axis-data", {});
        this.$emit("grouped-z-axis-data", {});
        this.$emit("color-group-key", "");
        this.$emit("color-group-display-name", "");
        if (!this.yAxisData || this.yAxisData.length === 0) {
          if (this.tableData && this.tableData.length > 0) {
            this.yAxisData = this.findYAxisData();
            const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
              ? this.selectedYAxisKey 
              : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
            const yAxisDisplayNames = yAxisKeys.map(key => {
              const selectedColumn = this.yAxisItems.find(item => item.name === key);
              return selectedColumn ? selectedColumn.displayName : key;
            });
            this.$emit("y-axis-selected", { data: this.yAxisData, displayNames: yAxisDisplayNames });
          }
        }
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.GroupColumn = ""
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
      }
    },
    async tableTypeChange(selectedType) {
      // Cancel any previous table type request
      this.cancelTableTypeRequest();
      
      // Create new AbortController for this request
      this.tableTypeAbortController = new AbortController();
      
      this.loadingXAxisData = true;
      this.loadingYAxisData = true;
      this.loadingZAxisData = true;
      this.selectedTableTypeName = selectedType;
      const tableTypeString = JSON.stringify(selectedType);
      localStorage.setItem("selectedTableType", this.selectedTableTypeName);
      
      try {
        const response = await api.get(
          "public/api/tables/type?table=" +
          encodeURIComponent(tableTypeString),
          { signal: this.tableTypeAbortController.signal }
        );
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.loadingXAxisData = false;
          this.loadingYAxisData = false;
          this.loadingZAxisData = false;
          
          const columns = response.data.data.tableTypes.columns.filter(column => column.displayName);
          columns.sort((a, b) => (a.columnSortOrder || 999) - (b.columnSortOrder || 999));
          
          this.xAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredXAxisItems = this.xAxisItems;
          
          this.yAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredYAxisItems = this.yAxisItems;
          
          this.zAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredZAxisItems = this.zAxisItems;
          
          
          this.colorGroupItems = columns.filter(column => column.legend)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.legendSortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredColorGroupItems = this.colorGroupItems;
          
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.TableType = this.selectedTableTypeName;
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
        } else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
        } else {
          this.showSnackbar("Error fetching table types.", "error");
        }
      } catch (error) {
        // Check if the request was cancelled
        if (error.name === 'AbortError') {
          return;
        }
        
        this.loadingXAxisData = false;
        this.loadingYAxisData = false;
        this.loadingZAxisData = false;
      } finally {
        // Clean up the AbortController
        this.tableTypeAbortController = null;
      }
    },
    createPlot() {
      this.$emit("create-plot");
    },
    
    checkAndApplyPendingFilter(chart) {
      // Check if there's a pending filter that should be applied
      const pendingFilterData = localStorage.getItem("pendingFilterData");
      const filterActive = localStorage.getItem("filterActive");
      
      if (pendingFilterData && filterActive === "true") {
        try {
          const filterData = JSON.parse(pendingFilterData);
          
          // Update the chart's Filter property with the pending filter data
          if (!chart.Filter) {
            chart.Filter = {};
          }
          
          // Apply the pending filter data to the chart
          Object.assign(chart.Filter, filterData);
          
          // Update the saved chart data with the filter
          localStorage.setItem('savedChartData', JSON.stringify(chart));
          
          // Clear the pending filter data since it's now applied
          localStorage.removeItem("pendingFilterData");
          
        } catch (error) {
          console.error("Error applying pending filter:", error);
          // Clear invalid pending filter data
          localStorage.removeItem("pendingFilterData");
        }
      }
    },
    
    checkForPendingFiltersOnMount() {
      // Check if there's a pending filter and a chart is already selected
      const pendingFilterData = localStorage.getItem("pendingFilterData");
      const filterActive = localStorage.getItem("filterActive");
      const savedChartData = localStorage.getItem("savedChartData");
      
      if (pendingFilterData && filterActive === "true" && savedChartData) {
        try {
          const chart = JSON.parse(savedChartData);
          const filterData = JSON.parse(pendingFilterData);
          
          // Apply the pending filter to the already selected chart
          if (!chart.Filter) {
            chart.Filter = {};
          }
          
          Object.assign(chart.Filter, filterData);
          localStorage.setItem('savedChartData', JSON.stringify(chart));
          localStorage.removeItem("pendingFilterData");
          
        } catch (error) {
          console.error("Error applying pending filter on mount:", error);
          localStorage.removeItem("pendingFilterData");
        }
      }
    },
    
    
    // Check if chart is public and created by current user
    isPublicChartByUser(chart) {
      const userEmail = this.$store.getters["tenantId/getUser"]?.username;
      const isPublic = chart.AccessLevel === 'public';
      const isCreatedByUser = chart.CreatedBy === userEmail;
      
      
      return isPublic && isCreatedByUser;
    },
    
    
    
    getSavedCharts() {
      this.showLoader = true;
      api
        .get("public/api/charts")
        .then((response) => {
          if (
            response &&
            response.data &&
            (response.data.statusCode === 200 ||
              response.data.statusCode === 201)
          ) {
            this.chartsArr = response.data.data.charts;
          }
        })
        .catch((error) => {
          // Handle error
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    // Method to select a chart by ID without reloading if already selected
    async selectChartById(chartId, forceRefresh = false) {
      // Check if the chart is already selected and not forcing refresh
      if (this.selectedChartId === chartId && !forceRefresh) {
        return;
      }
      
      // Find the chart with the matching ID
      const chart = this.chartsArr.find(c => c.ID === chartId);
      
      if (chart) {
        // Check if this chart is already loaded and avoid reloading (unless forcing refresh)
        if (!forceRefresh) {
          const currentSavedData = localStorage.getItem('savedChartData');
          if (currentSavedData) {
            try {
              const currentChart = JSON.parse(currentSavedData);
              if (currentChart.ID === chartId) {
                this.selectedChartId = chartId;
                this.$emit("selected-plot", chart);
                return;
              }
            } catch (e) {
              console.log('StudioList: Error parsing current saved data, proceeding with normal selection');
            }
          }
        }
        
        await this.selectChart(chart);
      } else {
        // If chart not found, refresh the list and try again
        this.getSavedCharts();
        
        // Try again after a short delay
        setTimeout(async () => {
          const retryChart = this.chartsArr.find(c => c.ID === chartId);
          if (retryChart) {
            await this.selectChart(retryChart);
          } else {
            console.log('StudioList: Chart still not found after refresh');
          }
        }, 1000);
      }
    },
  },
  mounted() {
    this.getSavedCharts();
    // Check for pending filters on component mount
    this.checkForPendingFiltersOnMount();
  },
};
</script>

<style scoped>
.dash-left-side {
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  background: #fff;
  border-right: 1px solid #e0e0e0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0,0,0,0.03);
  z-index: 2;
  padding: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dash-left-side {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .dash-left-side {
    width: 260px;
    min-width: 260px;
    max-width: 260px;
  }
}

.plot-header-row {
  display: flex;
  align-items: center;
}
.plot-title {
  font-size: 17.50px;
  font-weight: 600;
  color: #222;
}
.create-btn-compact {
  width: 10px;
  height: 32px !important;
  padding: 6px !important;
  min-width: 20px;
  min-height: 32px;
  max-height: 32px;
  border-radius: 6px;
  margin-left: 150px;
  object-fit: contain;
}
.tabs-row {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 0;
  padding-bottom: 0;
}
.dash-list-public {
  flex: 1;
  overflow-y: auto;
  padding: 0 0 8px 0;
}
.dash-list-items {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  margin: 2px 4px;
  font-size: 14.50px;
  transition: background 0.2s;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dash-list-items.active, .dash-list-items:hover {
  background: #f0f0f0;
  font-weight: bold;
  color: inherit;
  border: none;
}
.dash-name {
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
.globe-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  flex-shrink: 0;
}

/* Chart actions styles */
.chart-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 1;
  transition: opacity 0.2s;
}

</style> 